module.exports = __webpack_public_path__ + "img/indeximg11.352a18c4.jpg";